import { createModalContext } from "shared/components/vero-modal";

export const {
  Context: DeclineDealModalContext,
  Provider: DeclineDealModalProvider,
  useModalContext: useDeclineDealModal,
} = createModalContext();
